import { render, staticRenderFns } from "./LogoImgTheme.vue?vue&type=template&id=5aa21abd&scoped=true&"
import script from "./LogoImgTheme.vue?vue&type=script&lang=js&"
export * from "./LogoImgTheme.vue?vue&type=script&lang=js&"
import style0 from "./LogoImgTheme.vue?vue&type=style&index=0&id=5aa21abd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa21abd",
  null
  
)

export default component.exports